import { AlertDialog, DropdownMenu } from '@radix-ui/themes'
import * as React from 'react'

/* -------------------------------------------------------------------------------------------------
 * DropdownDialogItem
 * -----------------------------------------------------------------------------------------------*/

type DropdownDialogItemElement = React.ElementRef<typeof DropdownMenu.Item>
type DropdownDialogItemProps = React.ComponentPropsWithoutRef<
	typeof DropdownMenu.Item
> &
	Pick<
		React.ComponentPropsWithoutRef<typeof AlertDialog.Root>,
		'onOpenChange'
	> & {
		triggerChildren: React.ComponentPropsWithoutRef<
			typeof DropdownMenu.Item
		>['children']
	}

const DropdownDialogItem = React.forwardRef<
	DropdownDialogItemElement,
	DropdownDialogItemProps
>((props, forwardedRef) => {
	const { triggerChildren, children, onSelect, onOpenChange, ...itemProps } =
		props

	return (
		<AlertDialog.Root onOpenChange={onOpenChange}>
			<AlertDialog.Trigger>
				<DropdownMenu.Item
					{...itemProps}
					ref={forwardedRef}
					onSelect={(event) => {
						event.preventDefault()
						onSelect && onSelect(event)
					}}
				>
					{triggerChildren}
				</DropdownMenu.Item>
			</AlertDialog.Trigger>
			<AlertDialog.Content>{children}</AlertDialog.Content>
		</AlertDialog.Root>
	)
})
DropdownDialogItem.displayName = 'DropdownDialogItem'

/* -----------------------------------------------------------------------------------------------*/

export { DropdownDialogItem }
